import { ArrowUpRight } from "lucide-react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between gap-6 mb-8">
      <div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-semibold text-slate-900">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-slate-500 text-base max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent = "blue", testId }) {
  const accents = {
    blue: "text-blue-600 bg-blue-50",
    green: "text-emerald-600 bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    purple: "text-violet-600 bg-violet-50",
    slate: "text-slate-600 bg-slate-100",
  };
  return (
    <div
      data-testid={testId}
      className="bg-white border border-slate-200 rounded-xl p-6 hover:shadow-md hover:border-slate-300 transition-all"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-sm text-slate-500 font-medium">{label}</div>
          <div className="mt-2 text-3xl font-semibold text-slate-900 tracking-tight">
            {value}
          </div>
        </div>
        {Icon && (
          <div className={`w-10 h-10 rounded-lg grid place-items-center ${accents[accent]}`}>
            <Icon className="w-5 h-5" strokeWidth={2} />
          </div>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="bg-white border border-dashed border-slate-300 rounded-xl p-12 text-center">
      <div className="text-slate-700 font-medium">{title}</div>
      {hint && <p className="mt-1 text-sm text-slate-500">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function SectionCard({ title, children, action }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
        <div className="text-base font-semibold text-slate-900">{title}</div>
        {action}
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}

export function Pill({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700",
    blue: "bg-blue-50 text-blue-700",
    green: "bg-emerald-50 text-emerald-700",
    red: "bg-red-50 text-red-700",
    amber: "bg-amber-50 text-amber-700",
    indigo: "bg-indigo-50 text-indigo-700",
    purple: "bg-purple-50 text-purple-700",
  };
  return (
    <span className={`inline-flex items-center text-xs font-medium px-2 py-1 rounded-full ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function LinkRow({ children, onClick, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      className="w-full flex items-center justify-between px-4 py-3 rounded-lg hover:bg-slate-50 text-left transition-colors group"
    >
      <div>{children}</div>
      <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-blue-600" />
    </button>
  );
}
